import MasterService from "./MasterService";

const ContractService = {
    ...MasterService,

    getContractListing(params: object) {        
        return this.post('/partners/getContracts', params);
    },
    
    saveContract(params: object) {        
        return this.post('/partners/saveContract', params);
    }
}

export default ContractService;